import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFansLoader = (props) => /* @__PURE__ */ _jsxs("svg", {
	role: "img",
	width: 208,
	height: 920,
	"aria-labelledby": "loading-aria-fans",
	className: "OnlyFansCreatorsSidebar OnlyFansCreatorsSidebarLoader",
	viewBox: "0 0 208 920",
	preserveAspectRatio: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", {
			id: "loading-aria-fans",
			children: "Loading..."
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 0,
			width: "100%",
			height: "100%",
			clipPath: "url(#clip-path-fans)",
			style: { fill: "url(\"#fill-fans\")" }
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("clipPath", {
			id: "clip-path-fans",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 122,
					y: 119,
					rx: 0,
					ry: 0,
					width: 1,
					height: 0
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 234,
					y: 47,
					rx: 13,
					ry: 13,
					width: 66,
					height: 27
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 252,
					y: 2,
					rx: 14,
					ry: 14,
					width: 87,
					height: 28
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 316,
					y: 46,
					rx: 13,
					ry: 13,
					width: 112,
					height: 27
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 353,
					y: 2,
					rx: 13,
					ry: 13,
					width: 49,
					height: 27
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 441,
					y: 46,
					rx: 13,
					ry: 13,
					width: 49,
					height: 27
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 416,
					y: 1,
					rx: 14,
					ry: 14,
					width: 107,
					height: 28
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 503,
					y: 45,
					rx: 14,
					ry: 14,
					width: 68,
					height: 28
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 536,
					y: 1,
					rx: 14,
					ry: 14,
					width: 62,
					height: 28
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 582,
					y: 44,
					rx: 14,
					ry: 14,
					width: 203,
					height: 28
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 609,
					y: 0,
					rx: 14,
					ry: 14,
					width: 108,
					height: 28
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 12,
					y: 19,
					rx: 0,
					ry: 0,
					width: 178,
					height: 28
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 31,
					y: 534,
					rx: 13,
					ry: 13,
					width: 131,
					height: 31
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 32,
					y: 353,
					rx: 14,
					ry: 14,
					width: 134,
					height: 140
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 32,
					y: 504,
					rx: 0,
					ry: 0,
					width: 131,
					height: 16
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 31,
					y: 814,
					rx: 12,
					ry: 12,
					width: 131,
					height: 31
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 32,
					y: 633,
					rx: 14,
					ry: 14,
					width: 134,
					height: 140
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 32,
					y: 784,
					rx: 0,
					ry: 0,
					width: 131,
					height: 16
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 31,
					y: 257,
					rx: 13,
					ry: 13,
					width: 131,
					height: 31
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 32,
					y: 76,
					rx: 14,
					ry: 14,
					width: 134,
					height: 140
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 32,
					y: 227,
					rx: 0,
					ry: 0,
					width: 131,
					height: 16
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 21,
					y: 317,
					rx: 0,
					ry: 0,
					width: 157,
					height: 2
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 20,
					y: 597,
					rx: 0,
					ry: 0,
					width: 157,
					height: 2
				})
			]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "fill-fans",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .599964,
					stopColor: "#28272a",
					stopOpacity: 1,
					children: /* @__PURE__ */ _jsx("animate", {
						attributeName: "offset",
						values: "-2; -2; 1",
						keyTimes: "0; 0.25; 1",
						dur: "2s",
						repeatCount: "indefinite"
					})
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1.59996,
					stopColor: "#28272a",
					stopOpacity: 1,
					children: /* @__PURE__ */ _jsx("animate", {
						attributeName: "offset",
						values: "-1; -1; 2",
						keyTimes: "0; 0.25; 1",
						dur: "2s",
						repeatCount: "indefinite"
					})
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 2.59996,
					stopColor: "#28272a",
					stopOpacity: 1,
					children: /* @__PURE__ */ _jsx("animate", {
						attributeName: "offset",
						values: "0; 0; 3",
						keyTimes: "0; 0.25; 1",
						dur: "2s",
						repeatCount: "indefinite"
					})
				})
			]
		})] })
	]
});
export default SvgFansLoader;
